module.exports = __webpack_public_path__ + "img/discord.fd227367.png";